'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    BudgetFilterGroup: ()=>BudgetFilterGroup
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../../Slider/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../../../Text/index.cjs");
const external_Toggle_index_cjs_namespaceObject = require("../../../Toggle/index.cjs");
const external_FilterGroupWrapper_cjs_namespaceObject = require("../FilterGroupWrapper.cjs");
const CheckboxGroup_cjs_namespaceObject = require("../../../Checkbox/CheckboxGroup/CheckboxGroup.cjs");
function BudgetFilterGroup({ max, min = 0, currencyHelperText = '', currencySymbol = '', labelText = '', toggleLabel = '', onToggle = ()=>{}, title = '', options = [], avgPriceText = '', marks = [], collapsible = false, defaultCollapsed = false, isCheckboxToggledInitially = false }) {
    const [isCheckboxToggled, setIsCheckboxToggled] = (0, external_react_namespaceObject.useState)(isCheckboxToggledInitially);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_FilterGroupWrapper_cjs_namespaceObject.FilterGroupWrapper, {
        title: title,
        collapsible: collapsible,
        defaultCollapsed: defaultCollapsed,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: "border-primary-5 flex flex-row items-center rounded-full border py-2 pl-3 pr-2",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                            className: "w-full",
                            bold: true,
                            children: toggleLabel
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Toggle_index_cjs_namespaceObject.Toggle, {
                            checked: isCheckboxToggled,
                            onToggle: ()=>{
                                setIsCheckboxToggled((isCheckboxToggled)=>!isCheckboxToggled);
                                onToggle();
                            }
                        })
                    ]
                }),
                isCheckboxToggled ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: "flex flex-col gap-2",
                    "data-testid": "checkbox-group",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CheckboxGroup_cjs_namespaceObject.CheckboxGroup, {
                        options: options
                    })
                }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    "data-testid": "slider",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Slider, {
                            min: min,
                            max: max,
                            defaultValue: [
                                min,
                                max
                            ],
                            showValueText: true,
                            currencyHelperText: currencyHelperText,
                            currencySymbol: currencySymbol,
                            labelText: labelText,
                            marks: marks
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                            textStyle: "body2",
                            children: avgPriceText
                        })
                    ]
                })
            ]
        })
    });
}
exports.BudgetFilterGroup = __webpack_exports__.BudgetFilterGroup;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BudgetFilterGroup"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
